import { IconProps, iconA11yProps } from '../types';

export const ArrowDown = ({ classNames, label }: IconProps) => (
    <svg className={classNames} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 10" {...iconA11yProps(label)}>
        <path d="M12.76,2h0L8,7.08,3.24,2H12.76m0-2H3.24C1.49,0,.58,2.09,1.78,3.37l4.76,5.08c.4,.42,.93,.63,1.46,.63s1.06-.21,1.46-.63L14.22,3.37c1.2-1.28,.29-3.37-1.46-3.37h0Z" />
    </svg>
);
